/* angular:styles/component:css;a10ae783fbab19acb9e6e57a21c8b3d99515d7f4918cc1125e17c7af4ed224aa;/codebuild/output/src4169523549/src/friggkantine-admin/src/app/admin-dashboard/membership-v2/dialogs/credit-dialog.component.ts */
.v2-credit-cur,
.v2-credit-preview {
  font-size: 13px;
  margin: 4px 0 12px;
}
.full {
  width: 100%;
}
/*# sourceMappingURL=credit-dialog.component.css.map */
